export default {
  left: {
    textAlign: 'left'
  }
}
